import { makeObservable, observable, action } from 'mobx'
import axios from 'axios'
import { BaseStore } from './BaseStore'
import type { LineSetting, WebChatSetting } from '@/types'

export class SettingStore extends BaseStore {
  lineSetting: LineSetting | null = null
  webChatSetting: WebChatSetting | null = null

  constructor() {
    super()
    makeObservable(this, {
      lineSetting: observable,
      webChatSetting: observable,
      getLineSetting: action,
      updateLineSetting: action,
      getWebChatSetting: action,
      updateWebChatSetting: action
    })
  }

  async getLineSetting(tenantId: string) {
    const result = await this.handleApiCall(async () => {
      const response = await axios.get<LineSetting>(
        this.apiPath(`v1/tenants/${tenantId}/settings/line`),
        { headers: this.generateFetchHeader() }
      )
      return response.data
    })

    if (result) {
      this.lineSetting = result
      return true
    }
    return false
  }

  async updateLineSetting(tenantId: string, data: { channel_id: string; channel_secret: string; long_term_token: string }) {
    const result = await this.handleApiCall(async () => {
      await axios.put(
        this.apiPath(`v1/tenants/${tenantId}/settings/line`),
        data,
        { headers: this.generateFetchHeader() }
      )
      return true
    })

    if (result) {
      // 更新されたLINE設定を再取得
      await this.getLineSetting(tenantId)
      this.tryShowToast('LINE設定を更新しました', 'success')
      return true
    }

    this.tryShowToast('LINE設定の更新に失敗しました', 'error')
    return false
  }

  async getWebChatSetting(tenantId: string) {
    const result = await this.handleApiCall(async () => {
      const response = await axios.get<WebChatSetting>(
        this.apiPath(`v1/tenants/${tenantId}/settings/webchat`),
        { headers: this.generateFetchHeader() }
      )
      return response.data
    })

    if (result) {
      this.webChatSetting = result
      return true
    }
    return false
  }

  async updateWebChatSetting(tenantId: string, enabled: boolean) {
    const result = await this.handleApiCall(async () => {
      const response = await axios.put<WebChatSetting>(
        this.apiPath(`v1/tenants/${tenantId}/settings/webchat`),
        { enabled },
        { headers: this.generateFetchHeader() }
      )
      return response.data
    })

    if (result) {
      this.webChatSetting = result
      this.tryShowToast('Web設定を更新しました', 'success')
      return true
    }

    this.tryShowToast('Web設定の更新に失敗しました', 'error')
    return false
  }
}